import { combineReducers } from 'redux';
import { i18nReducer } from 'react-redux-i18n';

import orders from './orders';
import patients from './patients';

export default combineReducers({
	orders,
	patients,
	i18n: i18nReducer
});